import { Icon } from "@circleco/compass/components/Icon";
import { Tooltip } from "@circleco/compass/components/Tooltip";

import { t } from "@/i18n-js/instance";

export const CloseButton = ({
  onRemove,
}: {
  onRemove: (e: React.MouseEvent<HTMLButtonElement>) => void;
}) => (
  <Tooltip content={t("tiptap.attachment_previews.remove_link_preview")}>
    <button
      type="button"
      className="bg-inverse group absolute -right-3 -top-3 hidden cursor-pointer items-center justify-center rounded-full group-hover:flex border-2 border-tertiary"
      onClick={onRemove}
      aria-label={t("tiptap.attachment_previews.remove_link_preview")}
    >
      <Icon
        name="cross"
        aria-hidden
        size="sm"
        className="m-1"
        color="inverse"
      />
    </button>
  </Tooltip>
);
